import { render, staticRenderFns } from "./altaImpagoRechazada.vue?vue&type=template&id=1b71dfad&scoped=true&"
import script from "./altaImpagoRechazada.vue?vue&type=script&lang=js&"
export * from "./altaImpagoRechazada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b71dfad",
  null
  
)

export default component.exports